/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getSpecificPrivateTransactions,
  resetSpecificPrivateTxn,
  approvePrivateTxn,
  rejectPrivateTxn,
  addNewLabelPvt,
  removeNewLabelPvt,
} from "../../../redux/features/privatetransactions/privatetransactions.js";

import formatDateViewAll from "../../../utils/formatDateViewAll";
import formatCurrency from "../../../utils/CurrencyFormater";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";

import Loader from "../../../components/Loader/Index";
import PrimaryWithIconButton from "../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import TopNavLargeButton from "../../../components/_utils/CommonButtons/TopNavLargeButton";
import PositiveNegativeButton from "../../../components/_utils/CommonButtons/PositiveNegativeButton";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard/index.jsx";
import SvgComponent from "../../../components/_utils/SVGComponent/index.jsx";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard/index.jsx";
import TEXT from "../../../../src/utils/globalText.js";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  TimelineBarConfiguration,
} from "../../../utils/configurationProvider.js";
import CommonTimeLineCard from "../../../components/CommonTimeLineCard/index.jsx";
import useCategories from "../../../utils/useCategories.js";
import PrivateTxnEntry from "../../../components/_utils/PrivateTxnEntry/index.jsx";
import TimelineStatusBar from "../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import AuthenticationPopup from "../../../components/PrivateTransactions/AuthenticationPopup/index.jsx";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import ICONS from "../../../assets/Icons/index.js";
import Chips from "../../../components/_utils/CommonButtons/Chips/index.jsx";
import PrivateViewAllPopup from "./PrivateViewAllPopup/index.jsx";

const PrivateTxnDetail = ({
  type,
  private_id,
  closePrivateDetailModal,
  setPrivateTxnData,
}) => {
  const dispatch = useDispatch();
  const previousStatus = useLocation()?.state;
  const { id } = useParams();
  const navigate = useNavigate();
  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const leftContentRef = useRef(null);
  const arrowLeftimg =
    "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg";
  const [showDetails, setShowDetails] = useState(true);
  const [infoBox, setInfoBox] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [viewInternalTxnDetails, setViewInternalTxnDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);

  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const [showLabel, setShowLabel] = useState(false);
  const [initialStage, setInitialstage] = useState("details");
  const [labelDetails, setLabelDetails] = useState([]);
  const [labels, setLabels] = useState([]);
  const popupLabels = React.useMemo(() => {
    if (!Array.isArray(labels)) return [];
    return labels.filter((label) => !/[A-Z]/.test(label || ""));
  }, [labels]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const labelActionDispatchedRef = useRef(false);
  const [btnClicked, setbtnClicked] = useState({});
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [openAuthenticationPopup, setOpenAuthenticationPopup] = useState(false);
  const [openDeclinePopup, setOpenDeclinePopup] = useState(false);
  const [isLoadingDecline, setIsLoadingDecline] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(
      viewInternalTxnDetails?.[GlobalConfiguration?.lengthCheckZero]?.logs
        ?.length || GlobalConfiguration?.lengthCheckZero,
    ).fill(false),
  );
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState(
    Array(
      viewInternalTxnDetails?.[GlobalConfiguration?.lengthCheckZero]
        ?.distribution_logs?.length || GlobalConfiguration?.lengthCheckZero,
    ).fill(false),
  );
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);

  const approvalService = "APrivateTransaction";

  const validationService = services?.includes("ValidatorPrivateTransaction");

  const [rightHeight, setRightHeight] = useState("auto");

  const getStatusReason = () => {
    const txn = viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero];

    if (
      txn?.lifecycle_status === "rejected" ||
      txn?.lifecycle_status === "cancelled"
    ) {
      const logs = txn?.logs || [];
      const logWithReason = [...logs]
        .reverse()
        .find((log) => log?.rejection_reason);

      return (
        logWithReason?.rejection_reason ||
        txn?.rejection_reason ||
        txn?.reason ||
        specificPrivateTransactionsData?.transaction_request
          ?.rejection_reason ||
        "No reason provided"
      );
    }

    if (txn?.lifecycle_status === "failed") {
      return (
        txn?.errors?.[GlobalConfiguration.lengthCheckZero]?.error ||
        "Transaction failed"
      );
    }

    return null;
  };

  const displayReason = getStatusReason();
  const {
    specificPrivateTransactionsData,
    specificPrivateTransactionsLoading,
    otpValidationLoading,
    otpValidationError,
    otpValidationData,
  } = useSelector((state) => state.privatetransactions);
  const currentLabelTxn =
    specificPrivateTransactionsData?.transaction_request?.request_status ===
      "failed" ||
    specificPrivateTransactionsData?.transaction_request?.request_status ===
      "processing" ||
    specificPrivateTransactionsData?.transaction_request?.request_status ===
      "uploaded"
      ? specificPrivateTransactionsData?.transaction_request
      : specificPrivateTransactionsData?.private_transaction;

  let check = !(
    (services?.includes("Admin") ||
      services?.includes("ValidatorPrivateTransaction")) &&
    !!specificPrivateTransactionsData?.private_transaction
  );

  const categoryMapper = useCategories();

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const handleInputChange = (event) => {
    let value = event.target.value;

    // 1. Allow only alphanumeric + space
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    // 2. Remove leading spaces
    value = value.replace(/^\s+/, "");

    // 3. Allow only one space between words
    value = value.replace(/\s{2,}/g, " ");

    // 4. Limit to 150 characters
    value = value.slice(
      GlobalConfiguration?.lengthCheckZero,
      GlobalConfiguration?.inputMaxLength,
    );

    setDeclineReason(value);
  };

  async function fetchData() {
    if (specificPrivateTransactionsLoading) setLoading(true);
    try {
      let response;

      if (type === "private_detail_modal") {
        response = await dispatch(
          getSpecificPrivateTransactions({ id: private_id }),
        );
      } else {
        response = await dispatch(getSpecificPrivateTransactions({ id }));
      }
      if (
        response?.payload?.transaction_request?.request_status === "failed" ||
        response?.payload?.transaction_request?.request_status ===
          "processing" ||
        response?.payload?.transaction_request?.request_status === "uploaded"
      ) {
        setLabelDetails(response?.payload?.transaction_request?.labels || []);
      } else {
        setLabelDetails(response?.payload?.private_transaction?.labels || []);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  }

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(
        viewInternalTxnDetails?.[GlobalConfiguration?.lengthCheckZero]
          ?.distribution_logs?.length,
      ).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const handleDistributionClick = () => {
    SetopenTimelinePopup(true);
    setShowDistributionTimeline(true);
    if (!showDistributionTimeline) {
      setShowDetails(true);
      setShowAdditionalDetails(false);
      setShowApprovalTimeline(false);
      setShowLabel(false);
    }
    setOpenApprovalTimeline(false);
  };

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const toggleDetails = () => {
    setInitialstage("details");
    setShowDetails(true);
    setShowAdditionalDetails(false);
    setShowLabel(false);
  };

  const toggleLabels = () => {
    setInitialstage("label");
    setShowLabel(true);
    setShowDetails(false);
    setShowAdditionalDetails(false);
  };

  const toggleAdditionalDetails = () => {
    setInitialstage("transactiondetail");
    setShowAdditionalDetails(true);
    setShowDetails(false);
    setShowLabel(false);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleTimelinePopup = () => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);
    if (!showApprovalTimeline) {
      setShowDetails(true);
      setShowAdditionalDetails(false);
      setShowDistributionTimeline(false);
      setShowLabel(false);
    }
    setOpenDistributionTimeline(false);
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (labelActionDispatchedRef.current) {
      fetchData();
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(currentLabelTxn?.request_reference_id);

    const res = await dispatch(
      addNewLabelPvt({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabelPvt.fulfilled.match(res)) {
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (addNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(currentLabelTxn?.request_reference_id);
    const res = await dispatch(
      removeNewLabelPvt({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelPvt.fulfilled.match(res)) {
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (removeNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  const handleDeclinedDetails = async () => {
    CommonToast({
      text: "Rejecting transaction.",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
    try {
      setIsLoadingDecline(true);
      await delay(GlobalConfiguration?.delayTime);

      const data = await dispatch(
        rejectPrivateTxn({
          id: [
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.private_transaction_id,
          ],
          reason: declineReason,
        }),
      ).unwrap();

      if (data?.status) {
        setViewInternalTxnDetails((prev) =>
          prev.map((item) =>
            item?.private_transaction_id ===
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.private_transaction_id
              ? {
                  ...item,
                  lifecycle_status: data?.private_transaction?.status,
                  logs: data?.private_transaction?.logs,
                  statusName: "Approval Rejected",
                  statusColor: "text-failed",
                  barColor: "progress-rejected-approval",
                  barValue: TimelineBarConfiguration.smallwidth,
                }
              : item,
          ),
        );
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        if (type === "private_detail_modal") {
          setPrivateTxnData((prev) => ({
            ...prev,
            transaction_requests: prev?.transaction_requests?.map((item) =>
              item?.private_transaction_id ===
              viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
                ?.private_transaction_id
                ? {
                    ...item,
                    request_status: "rejected",
                    reason: declineReason,
                  }
                : item,
            ),
          }));
          setIsLoadingDecline(false);
          setOpenDeclinePopup(false);
          await delay(GlobalConfiguration?.delayTimeMid);
          closePrivateDetailModal();
        }
      }
    } catch (error) {
      await delay(GlobalConfiguration?.delayTime);
      if (type === "private_detail_modal") {
        setPrivateTxnData((prev) => ({
          ...prev,
          transaction_requests: prev?.transaction_requests?.map((item) =>
            item?.private_transaction_id ===
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.private_transaction_id
              ? {
                  ...item,
                  request_status: "error",
                }
              : item,
          ),
        }));
      }
      setErrorMessage(true);

      return error;
    } finally {
      setIsLoadingDecline(false);
      setbtnClicked((prev) => ({
        ...prev,
        [viewInternalTxnDetails[0]?.private_transaction_id]: "none",
      }));
      setOpenDeclinePopup(false);
    }
  };

  const addLifeCycleStatus = ({
    lifecycle_status,
    distribution_lifecycle_status,
    services = [],
    previousStatus,
  }) => {
    /* ---------- DEFAULT FALLBACK (ALWAYS SAFE) ---------- */
    let statusName = "Pending";
    let statusColor = "text-pending";

    let distributionStatusName = "N/A";
    let distributionStatusColor = "text-text-primary";

    let barColor = "progress-require-approval";
    let barValue = TimelineBarConfiguration.extrasmallwidth;

    /* ---------- MAIN LIFECYCLE STATUS ---------- */
    switch (lifecycle_status) {
      case "approval_pending":
        statusName = "Approval pending";
        statusColor = "text-pending";
        break;

      case "cancelled":
        statusName = "Validation rejected";
        statusColor = "text-failed";
        break;

      case "blocked":
        statusName = "Blocked";
        statusColor = "text-failed";
        break;

      case "created":
        statusName = services?.includes("ValidatorPrivateTransaction")
          ? "Require validation"
          : "Validation pending";
        statusColor = "text-pending";
        break;

      case "processing":
      case "uploaded":
        statusName = "Processing";
        statusColor = "text-queued";
        break;

      case "pending_for_otp":
      case "otp_requested":
      case "otp_submitted":
        statusName = services?.includes("OTPPrivateTransaction")
          ? "Require authentication"
          : "Authentication pending";
        statusColor = "text-pending";
        break;

      case "failed":
        statusName = "Process failed";
        statusColor = "text-failed";
        break;

      case "rejected":
        statusName = "Approval rejected";
        statusColor = "text-failed";
        break;

      case "approved":
        statusName = "Authenticated";
        statusColor = "text-awaiting";
        break;

      default:
        statusName = previousStatus
          ? previousStatus
          : services?.includes("APrivateTransaction")
            ? "Require approval"
            : "Approval pending";
        statusColor = "text-pending";
    }

    /* ---------- DISTRIBUTION STATUS ---------- */
    switch (distribution_lifecycle_status) {
      case "distribution_complete":
        distributionStatusName = "Distribution complete";
        distributionStatusColor = "text-settled";
        break;

      case "distribution_initiated":
        distributionStatusName = "Distribution initiated";
        distributionStatusColor = "text-queued";
        break;

      case "approved":
        distributionStatusName = "Distribution approved";
        distributionStatusColor = "text-positive-bg";
        break;

      case "created":
        distributionStatusName = "Distribution created";
        distributionStatusColor = "text-queued";
        break;

      case "awaiting_funds":
        distributionStatusName = "Awaiting funds";
        distributionStatusColor = "text-queued";
        break;

      case "rejected":
        distributionStatusName = "Distribution rejected";
        distributionStatusColor = "text-failed";
        break;

      case "failed":
        distributionStatusName = "Distribution failed";
        distributionStatusColor = "text-failed";
        break;

      case "abandoned":
        distributionStatusName = "Distribution abandoned";
        distributionStatusColor = "text-abandoned";
        break;

      default:
        distributionStatusName = "N/A";
        distributionStatusColor = "text-text-primary";
    }

    /* ---------- TIMELINE BAR LOGIC ---------- */
    if (
      ["rejected", "cancelled", "failed", "blocked"]?.includes(lifecycle_status)
    ) {
      barColor = "progress-rejected-approval";
      barValue = TimelineBarConfiguration.smallwidth;
    } else if (
      lifecycle_status === "abandoned" ||
      distribution_lifecycle_status === "abandoned"
    ) {
      barColor = "progress-abandoned-transaction";
      barValue =
        distribution_lifecycle_status === "abandoned"
          ? TimelineBarConfiguration.largewidth
          : TimelineBarConfiguration.smallwidth;
    } else {
      barColor = "progress-require-approval";
      barValue =
        distribution_lifecycle_status === "distribution_complete"
          ? TimelineBarConfiguration.largewidth
          : distribution_lifecycle_status
            ? TimelineBarConfiguration.mediumwidth
            : TimelineBarConfiguration.extrasmallwidth;
    }

    /* ---------- FINAL GUARANTEED RETURN ---------- */
    return {
      statusName,
      statusColor,
      distributionStatusName,
      distributionStatusColor,
      barColor,
      barValue,
    };
  };

  const handleDeclinePopup = () => {
    // handleApproveTransaction(id);

    setbtnClicked((prev) => ({
      ...prev,
      [viewInternalTxnDetails[0]?.private_transaction_id]: "Reject",
    }));
    setOpenDeclinePopup(true);
  };

  const handleApproveTransaction = async (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [id]: "Approve",
    }));

    CommonToast({
      text: "Approving transaction.",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
    try {
      const data = await dispatch(approvePrivateTxn({ id: [id] })).unwrap();

      await delay(GlobalConfiguration?.delayTime);

      if (data?.status) {
        if (data?.private_transaction?.status === "pending") {
          setViewInternalTxnDetails((prev) =>
            prev.map((item) =>
              item?.private_transaction_id === id
                ? {
                    ...item,
                    lifecycle_status: data?.private_transaction?.status,
                    logs: data?.private_transaction?.logs,
                    statusName: "Require Apprvoal",
                  }
                : item,
            ),
          );
        } else {
          setViewInternalTxnDetails((prev) =>
            prev.map((item) =>
              item?.private_transaction_id === id
                ? {
                    ...item,
                    lifecycle_status: data?.private_transaction?.status,
                    logs: data?.private_transaction?.logs,
                    statusName: "Require authentication",
                  }
                : item,
            ),
          );
        }

        CommonToast({
          text: "Transaction approved successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        if (type === "private_detail_modal") {
          if (data?.private_transaction?.status === "pending") {
            setPrivateTxnData((prev) => ({
              ...prev,
              transaction_requests: prev?.transaction_requests?.map((item) => {
                if (item?.private_transaction_id === id) {
                  return {
                    ...item,
                    request_status: "pendingOne",
                  };
                }

                return item;
              }),
            }));
          } else {
            setPrivateTxnData((prev) => ({
              ...prev,
              transaction_requests: prev?.transaction_requests?.filter(
                (item) => item?.private_transaction_id !== id,
              ),
              title: {
                ...prev.title,
                records: prev.title.records - 1,
              },
              total_count: prev?.total_count - 1,
            }));
          }

          await delay(GlobalConfiguration?.delayTimeMid);

          closePrivateDetailModal();
        }
      }
    } catch (error) {
      setbtnClicked((prev) => ({
        ...prev,
        [id]: "none",
      }));
      await delay(GlobalConfiguration?.delayTime);
      if (type === "private_detail_modal") {
        setPrivateTxnData((prev) => ({
          ...prev,
          transaction_requests: prev?.transaction_requests?.map((item) =>
            item?.private_transaction_id ===
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.private_transaction_id
              ? {
                  ...item,
                  request_status: "error",
                }
              : item,
          ),
        }));
      }
      setErrorMessage(true);
      return error;
    } finally {
      setbtnClicked({});
    }
  };
  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(resetSpecificPrivateTxn());
    };
  }, []);

  useEffect(() => {
    if (leftContentRef.current) {
      setRightHeight(leftContentRef.current.offsetHeight);
    }
  }, [viewInternalTxnDetails]);

  useEffect(() => {
    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    if (
      specificPrivateTransactionsData &&
      !specificPrivateTransactionsLoading &&
      !isLoading
    ) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          specificPrivateTransactionsData?.transaction_request?.request_status,
        distribution_lifecycle_status:
          specificPrivateTransactionsData?.private_transaction
            ?.distribution_transaction_details?.distribution_lifecycle_status,
        services,
        previousStatus: previousStatus,
      });

      const newData = [
        {
          ...specificPrivateTransactionsData?.private_transaction,
          ...specificPrivateTransactionsData?.transaction_request,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          lifecycle_status:
            specificPrivateTransactionsData?.transaction_request
              ?.request_status,
          distribution_lifecycle_status:
            specificPrivateTransactionsData?.private_transaction
              ?.distribution_transaction_details?.distribution_lifecycle_status,
          distribution_logs:
            specificPrivateTransactionsData?.private_transaction
              ?.distribution_transaction_details?.distribution_logs,
          ...uiState,
        },
      ];

      setViewInternalTxnDetails(newData);
    }
  }, [
    specificPrivateTransactionsData,
    specificPrivateTransactionsLoading,
    services,
  ]);

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem("AvailableLabelsPvt");
    const parsedLabels = JSON?.parse(availableLabels) || [];
    setLabels(parsedLabels);
  }, []);

  useEffect(() => {
    if (!showLabelsPopup) return;
    const availableLabels = sessionStorage?.getItem("AvailableLabelsPvt");
    const parsedLabels = JSON?.parse(availableLabels) || [];
    setLabels(parsedLabels);
  }, [showLabelsPopup]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={popupLabels}
            setLabels={setLabels}
            LabelAccounts={currentLabelTxn?.request_reference_id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={
              currentLabelTxn
                ? [
                    {
                      ...currentLabelTxn,
                      id: currentLabelTxn?.request_reference_id,
                    },
                  ]
                : []
            }
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {openDeclinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            // btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!isLoadingDecline) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            // End of Input Field Props
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!isLoadingDecline) {
                setOpenDeclinePopup(false);
                setDeclineReason("");

                setbtnClicked((prev) => ({
                  ...prev,
                  [viewInternalTxnDetails[0]?.private_transaction_id]: "none",
                }));
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              // setbtnClicked((prev) => ({
              //   ...prev,
              //   [viewInternalTxnDetails[0]?.private_transaction_id]:
              //     "Reject",
              // }));
              handleDeclinedDetails();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.length < GlobalConfiguration?.panLength ||
              isLoadingDecline
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={isLoadingDecline ? true : false}
            btnTwoIsLoading={isLoadingDecline ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="File timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={
                "https://q2pay.in/new_assets/common/create_flow/close.svg"
              }
              isscrollRequired={true}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
            >
              <TimelinePopupContent
                logsData={viewInternalTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {openTransHistory && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <PrivateViewAllPopup
            onClose={() => {
              closeTransactionHistory();
            }}
            setOpenTransHistory={setOpenTransHistory}
            type={"private_view_modal"}
            currentCat={
              viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
                ?.category
            }
            setInitialstage={setInitialstage}
            setShowDetails={setShowDetails}
            setShowLabel={setShowLabel}
            setShowAdditionalDetails={setShowAdditionalDetails}
            openTransHistory={openTransHistory}
          />
        </div>
      )}
      {openAuthenticationPopup && (
        <AuthenticationPopup
          setOpenAuthenticationPopup={setOpenAuthenticationPopup}
          openAuthenticationPopup={openAuthenticationPopup}
          otpValidationLoading={otpValidationLoading}
          otpValidationError={otpValidationError}
          otpValidationData={otpValidationData}
          setPrivateTxnData={setPrivateTxnData}
          delay={delay}
          id={
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.private_transaction_id
          }
          ref_id={
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.request_reference_id
          }
          currentOtpCount={
            viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
              ?.otp_attempts_count
          }
          setViewInternalTxnDetails={setViewInternalTxnDetails}
          type={"detail_page"}
          isPopup={type === "private_detail_modal"}
        />
      )}
      {loading ||
      !viewInternalTxnDetails[GlobalConfiguration?.lengthCheckZero]
        ?.lifecycle_status ||
      !specificPrivateTransactionsData ? (
        <div className="fixed inset-0 flex items-center justify-center m-auto">
          <Loader />
        </div>
      ) : (
        <div
          className={`${type === "private_detail_modal" ? "h-full" : "h-screen"} w-full ${showLabelsPopup || openAuthenticationPopup ? "overflow-hidden" : "overflow-y-auto"}`}
        >
          <div
            className={`bg-primary-nav shadow-box-shadow-bottom fixed top-top-base left-left-base z-z-index-overlay w-width-full ${type === "private_detail_modal" ? "hidden" : "Qsmd:hidden block"}  `}
          >
            <div className="w-width-full flex flex-row items-center">
              <div
                className="p-padding-md"
                onClick={() =>
                  navigate(GlobalConfiguration.lengthCheckNegativeOne)
                }
              >
                <SvgComponent
                  url={arrowLeftimg}
                  color="var(--text-primary)"
                  height="var(--icon-md)"
                  width="var(--icon-md)"
                />
              </div>
              <div className="flex flex-col w-width-full py-padding-sm gap-y-gap-xs">
                <div className="text-font-md text-text-primary text-left font-sans font-normal">
                  Private transaction
                </div>
                <div className="text-font-xs text-text-secondary text-left font-sans font-semibold">
                  Transaction details
                </div>
              </div>
            </div>
          </div>
          {/* ------------------------------------------------------------------------------------------------------------------------------------Nav Div Start-------------------------------------------------------------------------------------------- */}
          <div
            className={` ${type === "private_detail_modal" ? "hidden" : "Qsmd:block hidden"}  h-navbar-breadcrumb-height bg-primary-nav`}
          ></div>
          {/* ------------------------------------------------------------------------------------------------------------------------------------Nav Div end-------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------------Detail Div Start-------------------------------------------------------------------------------------------- */}
          <div
            className={`w-full relative flex Qsmd:mt-margin-base bg-primary-nav ${type === "private_detail_modal" ? "pt-padding-base" : "Qsmd:pt-padding-base pt-[63px]"}`}
          >
            <div
              key={
                specificPrivateTransactionsData?.transaction_request
                  ?.request_reference_id
              }
              className={`w-width-full h-auto  pt-padding-base`}
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                maxWidth: "var(--max-content-width)",
              }}
            >
              <div className="flex flex-col lg:flex-row border-b border-solid border-primary-bg">
                <div className="flex flex-row my-margin-md  w-width-full lg:w-width-md justify-between px-padding-md lg:px-padding-base relative ">
                  <div className="flex flex-col mt-margin-xs  relative  Qlg:pl-padding-sm pl-padding-base">
                    <div className="flex flex-row gap-x-gap-xs relative">
                      <div>
                        <TitleSubtitlePair
                          title={
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "processing" ||
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "uploaded"
                              ? "-"
                              : specificPrivateTransactionsData
                                    ?.transaction_request?.request_status ===
                                  "failed"
                                ? "N/A"
                                : `INR ${formatCurrency(specificPrivateTransactionsData?.private_transaction?.total_amount)}`
                          }
                          titleColor={
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "processing" ||
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "failed" ||
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "uploaded"
                              ? "text-primary"
                              : "settled"
                          }
                          subtitle="Transaction amount"
                          info={false}
                          onClick={showAmountInfo}
                          alignRight={false}
                          hoverOption="white"
                          isBold={
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "processing" ||
                            specificPrivateTransactionsData?.transaction_request
                              ?.request_status === "uploaded"
                              ? "-"
                              : specificPrivateTransactionsData
                                    ?.transaction_request?.request_status ===
                                  "failed"
                                ? false
                                : true
                          }
                          variant="md"
                        />
                      </div>

                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="lg:border-l border-b lg:border-b-0 border-solid border-primary-bg lg:my-margin-md"></div>
                <div className="flex flex-row justify-between w-width-full lg:w-width-md px-padding-md lg:px-padding-base">
                  <div className="lg:ml-margin-md my-margin-md lg:mt-margin-md lg:py-padding-xs">
                    <TitleSubtitlePair
                      isDisabled={false}
                      alignRight={false}
                      title={
                        specificPrivateTransactionsData?.transaction_request
                          ?.file_name
                      }
                      titleColor={"text-primary"}
                      subtitle={"File name"}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />
                  </div>
                </div>
                <div className="hidden lg:flex">
                  <TopNavSmallButton
                    btnText={
                      viewInternalTxnDetails[
                        GlobalConfiguration?.lengthCheckZero
                      ]?.category
                    }
                    handleFunction={() => {
                      if (type === "private_detail_modal") {
                        actionRestricted();
                      } else {
                        openTransactionHistory();
                      }
                    }}
                    icon={categoryMapper(
                      specificPrivateTransactionsData?.transaction_request
                        ?.category,
                    )}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    hoverOption="white"
                    isDisabled={type === "private_detail_modal"}
                  />
                </div>
              </div>

              <div className="flex Qlg:flex-row flex-col">
                <div className="flex flex-row items-center justify-between Qlg:w-width-md w-width-full Qlg:px-padding-base px-padding-sm Qlg:p-padding-base py-padding-sm border-b border-primary-bg Qlg:border-b-0">
                  <TitleSubtitlePair
                    isDisabled={
                      !services?.includes("VAccount") ||
                      type === "private_detail_modal"
                    }
                    alignRight={false}
                    title={formatAccountNumber(
                      specificPrivateTransactionsData?.transaction_request
                        ?.owner_account_details?.owner_account_bank_acc_no,
                    )}
                    titleColor={"text-primary"}
                    subtitle={"Source account"}
                    onClick={() => {
                      if (type === "private_detail_modal") {
                        actionRestricted();
                      } else if (!services?.includes("VAccount")) {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VAccount",
                          },
                        });
                      } else {
                        navigate(
                          `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${
                            specificPrivateTransactionsData?.transaction_request
                              ?.owner_account_details?.owner_account_id
                          }`,
                        );
                      }
                    }}
                    info={false}
                    showArrow={true}
                    hoverOption={"white"}
                    isBold={false}
                    variant={"md"}
                  />
                  <div className="Qlg:mr-margin-md">
                    <CommonBankLogo
                      ifsc={
                        specificPrivateTransactionsData?.transaction_request
                          ?.owner_account_details?.owner_account_ifsc_code
                      }
                      variant="big"
                      type="pill"
                    />
                  </div>
                </div>
                <div className="lg:border-l border-b lg:border-b-0 border-solid border-primary-bg lg:my-margin-md Qlg:block hidden"></div>

                <div className="w-width-full Qsmd:w-width-md flex justify-between gap-gap-md py-padding-md Qlg:py-padding-base">
                  <div className="flex flex-row items-center pl-padding-md">
                    <div>
                      <TitleSubtitlePair
                        isDisabled={false}
                        alignRight={false}
                        title={
                          specificPrivateTransactionsData?.transaction_request
                            ?.request_status === "processing" ||
                          specificPrivateTransactionsData?.transaction_request
                            ?.request_status === "uploaded"
                            ? "-"
                            : specificPrivateTransactionsData
                                  ?.transaction_request?.request_status ===
                                "failed"
                              ? "N/A"
                              : specificPrivateTransactionsData
                                  ?.private_transaction
                                  ?.total_beneficiary_account_count
                        }
                        titleColor={"text-primary"}
                        subtitle={"Total beneficiary accounts"}
                        info={false}
                        showArrow={false}
                        isBold={false}
                        variant={"md"}
                      />
                    </div>
                  </div>
                </div>
                <div className="Qsmd:invisible Qlg:flex hidden">
                  <TopNavSmallButton
                    btnText={
                      <>
                        {" "}
                        Transaction <br /> history
                      </>
                    }
                    handleFunction={() => {
                      if (type === "private_detail_modal") {
                        actionRestricted();
                      } else {
                        openTransactionHistory();
                      }
                    }}
                    icon={categoryMapper(
                      specificPrivateTransactionsData?.transaction_request
                        ?.category,
                    )}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    hoverOption="white"
                    isDisabled={type === "private_detail_modal"}
                  />
                </div>
              </div>
              <div className="Qlg:hidden block bg-primary-nav">
                <TimelineStatusBar
                  showMobile={true}
                  key={viewInternalTxnDetails?.[0]?.txn_id}
                  overrideAutoLoader
                  isLoading={specificPrivateTransactionsLoading}
                  failedToTakeaction={errorMessage}
                  failedToTakeIcon={true}
                  rejected={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "rejected"
                  }
                  // rejectedReason={
                  //   displayReason?.length > GlobalConfiguration.inputMaxLength
                  //     ? displayReason.slice(
                  //         GlobalConfiguration.lengthCheckZero,
                  //         GlobalConfiguration.inputMaxLength,
                  //       ) + "..."
                  //     : displayReason
                  // }
                  rejectedReason={displayReason}
                  furtherApprovalPending={
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      "pending" &&
                    viewInternalTxnDetails?.[0]?.logs[
                      viewInternalTxnDetails?.[0]?.logs.length -
                        GlobalConfiguration.lengthCheckOne
                    ]?.final_approval === false &&
                    viewInternalTxnDetails?.[0]?.logs[
                      viewInternalTxnDetails?.[0]?.logs.length -
                        GlobalConfiguration.lengthCheckOne
                    ]?.user_id === loginid?.employees?.id
                  }
                  blocked={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "blocked"
                  }
                  cancelled={
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    "cancelled"
                  }
                  cancelledReason={displayReason}
                  // cancelledReason={
                  //   viewInternalTxnDetails?.[0]?.logs[
                  //     GlobalConfiguration.lengthCheckOne
                  //   ]?.rejection_reason?.length >
                  //   GlobalConfiguration.inputMaxLength
                  //     ? viewInternalTxnDetails?.[0]?.logs[
                  //         GlobalConfiguration.lengthCheckOne
                  //       ]?.rejection_reason.slice(
                  //         GlobalConfiguration.lengthCheckZero,
                  //         GlobalConfiguration.inputMaxLength,
                  //       ) + "..."
                  //     : viewInternalTxnDetails?.[0]?.logs[
                  //         GlobalConfiguration.lengthCheckOne
                  //       ]?.rejection_reason
                  // }
                  pending={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "pending"
                  }
                  whichBtnClicked={
                    btnClicked?.[
                      viewInternalTxnDetails?.[0]?.private_transaction_id
                    ] || "none"
                  }
                  rejectMobClick={() => {
                    if (services?.includes("APrivateTransaction")) {
                      handleDeclinePopup();
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "APrivateTransaction",
                        },
                      });
                    }
                  }}
                  isRejectMobDisable={
                    !services?.includes("APrivateTransaction")
                  }
                  approveMobClick={() => {
                    if (services?.includes("APrivateTransaction")) {
                      setbtnClicked((prev) => ({
                        ...prev,
                        [viewInternalTxnDetails?.[0]?.private_transaction_id]:
                          "Approve",
                      }));
                      handleApproveTransaction(
                        viewInternalTxnDetails?.[0]?.private_transaction_id,
                      );
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "APrivateTransaction",
                        },
                      });
                    }
                  }}
                  isApproveMobDisable={
                    !services?.includes("APrivateTransaction")
                  }
                  failed={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "failed"
                  }
                  // failedReason={
                  //   displayReason?.length > GlobalConfiguration.inputMaxLength
                  //     ? displayReason.slice(
                  //         GlobalConfiguration.lengthCheckZero,
                  //         GlobalConfiguration.inputMaxLength,
                  //       ) + "..."
                  //     : displayReason
                  // }
                  failedReason={displayReason}
                  // failedReason={
                  //   viewInternalTxnDetails?.[0]?.errors[
                  //     GlobalConfiguration.lengthCheckZero
                  //   ]?.error?.length > GlobalConfiguration.inputMaxLength
                  //     ? viewInternalTxnDetails?.[0]?.errors[
                  //         GlobalConfiguration.lengthCheckZero
                  //       ]?.error.slice(
                  //         GlobalConfiguration.lengthCheckZero,
                  //         GlobalConfiguration.inputMaxLength,
                  //       ) + "..."
                  //     : viewInternalTxnDetails?.[0]?.errors[
                  //         GlobalConfiguration.lengthCheckZero
                  //       ]?.error
                  // }
                  processing={
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    "processing"
                  }
                  uploaded={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "uploaded"
                  }
                  created={
                    viewInternalTxnDetails?.[0]?.lifecycle_status === "created"
                  }
                  createText={
                    validationService
                      ? TEXT.REQUIRE_VALIDATION
                      : TEXT?.PENDING_VALIDATION
                  }
                  handleCreateBtn={() => {
                    if (validationService) {
                      navigate(
                        `/private_transaction_dashboard/require_validation/validate_file/${viewInternalTxnDetails?.[0]?.request_reference_id}`,
                      );
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "ValidatorPrivateTransaction",
                        },
                      });
                    }
                  }}
                  isCreateDisabled={!validationService}
                  otp={
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      "pending_for_otp" ||
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      "otp_requested" ||
                    viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      "otp_submitted"
                  }
                  otpHeader={
                    services?.includes("OTPPrivateTransaction")
                      ? TEXT.AUTH_REQUIRE
                      : TEXT.AUTH_Pending
                  }
                  otpSubHeader={TEXT.AUTH_REQUIRE_MSG}
                  handleOtpFunction={() => {
                    if (services?.includes("OTPPrivateTransaction")) {
                      setOpenAuthenticationPopup(true);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "OTPPrivateTransaction",
                        },
                      });
                    }
                  }}
                  isOtpDisabled={!services?.includes("OTPPrivateTransaction")}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col w-width-full mt-margin-md Qlg:hidden">
            <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
              Quick Action
            </div>

            <TopNavSmallButton
              btnText={
                viewInternalTxnDetails[GlobalConfiguration.lengthCheckZero]
                  ?.category
              }
              btnType="button"
              icon={categoryMapper(
                viewInternalTxnDetails[GlobalConfiguration.lengthCheckZero]
                  ?.category,
              )}
              handleFunction={() => {
                if (type === "private_detail_modal") {
                  actionRestricted();
                } else {
                  openTransactionHistory();
                }
              }}
              isDisabled={type === "private_detail_modal"}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              disabledBgColor="var(--primary-nav-act)"
              hoverOption="white"
              fullWidthRequired={true}
            />
          </div>
          {/* ------------------------------------------------------------------------------------------------------------------------------------Detail Div end-------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------------------------------------------------------------------------------Timeline Div Start-------------------------------------------------------------------------------------------- */}
          {/* ------------------------------------------------------------Timeline Start--------------------------------------------------------------------------------------------------- */}
          <div className="flex-row w-width-full timeline_box max-w-tab-width-normal m-auto flex justify-start">
            <div
              className={`
  bg-primary-card flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto mt-margin-md overflow-hidden relative rounded-bl-border-radius-md rounded-tl-border-radius-md rounded-tr-border-radius-md  ${viewInternalTxnDetails?.[0]?.distribution_logs !== undefined ? "rounded-br-border-radius-md" : " Qlg:rounded-br-none  rounded-br-border-radius-md"}`}
            >
              <div
                className={`flex flex-col w-full  h-auto   ${
                  viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
                    ?.distribution_logs === undefined
                    ? " rounded-bl-border-radius-md  rounded-br-border-radius-md"
                    : "rounded-b-border-radius-md"
                } rounded-t-border-radius-md overflow-hidden relative`}
              >
                {/* TITLE */}
                <div className="pt-px bg-primary-nav rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md">
                  <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                    File Timeline
                  </p>
                  <div className="border-b border-primary-bg"></div>
                </div>
                <div ref={leftContentRef}>
                  <CommonTimeLineCard
                    logsData={viewInternalTxnDetails}
                    handleApprovalClick={handleTimelinePopup}
                    handleDistributionClick={handleDistributionClick}
                    showApprovalTimeline={showApprovalTimeline}
                    showDistributionTimeline={showDistributionTimeline}
                    showDistributionRightIcon={true}
                    showApprovalLeftIcon={true}
                    isDisabled={type === "private_detail_modal"}
                    leftArrowDisabled={
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "failed" ||
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "processing" ||
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "uploaded"
                    }
                    cardType={"double"}
                  />
                </div>
              </div>
            </div>
            {/* Web Time line component  */}
            <div className="Qlg:w-width-md Qlg:h-full">
              <TimelineStatusBar
                showMobile={false}
                key={viewInternalTxnDetails?.[0]?.txn_id}
                overrideAutoLoader
                whichBtnClicked={
                  btnClicked?.[
                    viewInternalTxnDetails?.[0]?.private_transaction_id
                  ] || "none"
                }
                // isLoading={specificPrivateTransactionsLoading}
                failedToTakeaction={errorMessage}
                failedToTakeIcon={true}
                rejected={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "rejected"
                }
                // rejectedReason={
                //   displayReason?.length > GlobalConfiguration.inputMaxLength
                //     ? displayReason.slice(
                //         GlobalConfiguration.lengthCheckZero,
                //         GlobalConfiguration.inputMaxLength,
                //       ) + "..."
                //     : displayReason
                // }
                rejectedReason={displayReason}
                furtherApprovalPending={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "pending" &&
                  viewInternalTxnDetails?.[0]?.logs[
                    viewInternalTxnDetails?.[0]?.logs.length -
                      GlobalConfiguration.lengthCheckOne
                  ]?.final_approval === false &&
                  viewInternalTxnDetails?.[0]?.logs[
                    viewInternalTxnDetails?.[0]?.logs.length -
                      GlobalConfiguration.lengthCheckOne
                  ]?.user_id === loginid?.employees?.id
                }
                blocked={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "blocked"
                }
                cancelled={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "cancelled"
                }
                cancelledReason={displayReason}
                // cancelledReason={
                //   viewInternalTxnDetails?.[0]?.logs[
                //     GlobalConfiguration.lengthCheckOne
                //   ]?.rejection_reason?.length >
                //   GlobalConfiguration.inputMaxLength
                //     ? viewInternalTxnDetails?.[0]?.logs[
                //         GlobalConfiguration.lengthCheckOne
                //       ]?.rejection_reason.slice(
                //         GlobalConfiguration.lengthCheckZero,
                //         GlobalConfiguration.inputMaxLength,
                //       ) + "..."
                //     : viewInternalTxnDetails?.[0]?.logs[
                //         GlobalConfiguration.lengthCheckOne
                //       ]?.rejection_reason
                // }
                pending={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "pending"
                }
                rejectClick={() => {
                  if (services?.includes("APrivateTransaction")) {
                    handleDeclinePopup();
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "APrivateTransaction",
                      },
                    });
                  }
                }}
                isRejectDisable={!services?.includes("APrivateTransaction")}
                approveClick={() => {
                  if (services?.includes("APrivateTransaction")) {
                    setbtnClicked((prev) => ({
                      ...prev,
                      [viewInternalTxnDetails?.[0]?.private_transaction_id]:
                        "Approve",
                    }));
                    handleApproveTransaction(
                      viewInternalTxnDetails?.[0]?.private_transaction_id,
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "APrivateTransaction",
                      },
                    });
                  }
                }}
                isApproveDisable={!services?.includes("APrivateTransaction")}
                failed={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "failed"
                }
                // failedReason={
                //   displayReason?.length > GlobalConfiguration.inputMaxLength
                //     ? displayReason.slice(
                //         GlobalConfiguration.lengthCheckZero,
                //         GlobalConfiguration.inputMaxLength,
                //       ) + "..."
                //     : displayReason
                // }
                failedReason={displayReason}
                processing={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "processing"
                }
                uploaded={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "uploaded"
                }
                created={
                  viewInternalTxnDetails?.[0]?.lifecycle_status === "created"
                }
                createText={
                  validationService
                    ? TEXT.REQUIRE_VALIDATION
                    : TEXT?.PENDING_VALIDATION
                }
                handleCreateBtn={() => {
                  if (validationService) {
                    navigate(
                      `/private_transaction_dashboard/require_validation/validate_file/${viewInternalTxnDetails?.[0]?.request_reference_id}`,
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "ValidatorPrivateTransaction",
                      },
                    });
                  }
                }}
                isCreateDisabled={!validationService}
                otp={
                  viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    "pending_for_otp" ||
                  viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    "otp_requested" ||
                  viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    "otp_submitted"
                }
                otpHeader={
                  services?.includes("OTPPrivateTransaction")
                    ? TEXT.AUTH_REQUIRE
                    : TEXT.AUTH_Pending
                }
                otpSubHeader={TEXT.AUTH_REQUIRE_MSG}
                handleOtpFunction={() => {
                  if (services?.includes("OTPPrivateTransaction")) {
                    setOpenAuthenticationPopup(true);
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "OTPPrivateTransaction",
                      },
                    });
                  }
                }}
                isOtpDisabled={!services?.includes("OTPPrivateTransaction")}
              />
            </div>
          </div>
          {/* ---------------------------------------------------------------Timeline End-------------------------------------------------------------------------------------------------------- */}
          {/* ---------------------------------------------------------------------------------Card Detail Start-------------------------------------------------------------------------------------------- */}
          <div
            className={`details-div-trans  Qlg:pt-padding-base mb-margin-md `}
          >
            <div className="detail-section-trans h-auto m-auto max-w-tab-width-normal">
              <div className="flex pt-padding-md  Qsmd:pl-padding-base Qlg:ml-margin-base ml-margin-md mr-margin-md">
                <div className="flex switch-tab-parent gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                  <SwitcherTabs
                    initialActiveTab={initialStage}
                    tabs={[
                      {
                        label: "Details",
                        handler: toggleDetails,
                        key: "details",
                      },
                      {
                        label: "Transaction details",
                        handler: toggleAdditionalDetails,
                        key: "additional_details",
                        isDisabled: check,
                      },
                      {
                        label: "Labels",
                        handler: toggleLabels,
                        key: "assigned labels",
                      },
                    ]}
                  />
                </div>
              </div>
              {showDetails &&
                viewInternalTxnDetails?.map((account) => {
                  /**
                   * @type {import("../../../components/_utils/CommonDetailCard/index.jsx").Entry[]}
                   */
                  let originItemList = [
                    {
                      content: account?.uploaded_by
                        ? account?.uploaded_by[
                            GlobalConfiguration.lengthCheckZero
                          ]?.toUpperCase() +
                          account?.uploaded_by.slice(
                            GlobalConfiguration.lengthCheckOne,
                          )
                        : "N/A",
                      heading: "Created by",
                      type: "text",
                    },
                    {
                      content: account?.created_at
                        ? formatDateViewAll(account?.created_at, true, true)
                        : "N/A",
                      heading: "Created on",
                      type: "text",
                    },
                  ];

                  /** 
           

              /**
               * @type {import("../../../components/_utils/CommonDetailCard/index.jsx").Entry[]}
               */
                  let supportItemList = [
                    {
                      content: account?.request_reference_id,
                      heading: "File ID",
                      type: "text",
                    },
                    {
                      content: account?.private_transaction_id || "N/A",
                      heading: "Transaction ID",
                      type: "text",
                    },
                  ];

                  return (
                    <div
                      className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md  `}
                    >
                      <CommonDetailCard
                        cardTitle="Origin Details"
                        numCols={1}
                        variant="third"
                        entries={originItemList}
                      />

                      <CommonDetailCard
                        cardTitle="Support Information"
                        numCols={1}
                        variant="third"
                        entries={supportItemList}
                      />
                    </div>
                  );
                })}

              {showAdditionalDetails && (
                <div className="flex flex-col lg:flex-col items-center Qmd:items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base relative z-z-index-base">
                  {viewInternalTxnDetails[
                    GlobalConfiguration.lengthCheckZero
                  ]?.transaction_items?.map((val) => {
                    return (
                      <PrivateTxnEntry
                        column1Title={
                          viewInternalTxnDetails[
                            GlobalConfiguration.lengthCheckZero
                          ]?.created_by
                        }
                        column1Subtitle="Beneficiary name"
                        column2Title={formatAccountNumber(
                          val?.beneficiary_account,
                        )}
                        column2Subtitle="Beneficiary account"
                        column3Title={val?.amount}
                        column3Subtitle="Transaction amount"
                        showCurrencySymbol={true}
                        showActions={false}
                        ifsc={val?.beneficiary_account_ifsc}
                        key={val?.transaction_item_id}
                      />
                    );
                  })}
                </div>
              )}

              {showLabel && (
                <>
                  <div className="mt-margin-md">
                    <CommonContainerCard
                      header="Labels"
                      subheader="Labels will be used to generate statistics for the associated private transactions."
                      icon={
                        "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                      }
                      iconIsDisabled={type === "private_detail_modal"}
                      handleFunction={(e) => {
                        e.stopPropagation();
                        if (type === "private_detail_modal") {
                          actionRestricted();
                          return;
                        }

                        if (
                          !(
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          )
                        ) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                          return;
                        }

                        // if (type === "internal_txn_detail_modal") {
                        //   actionRestricted();
                        //   return;
                        // }

                        setShowLabelsPopup(true);
                      }}
                    >
                      <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                        {Array.isArray(labelDetails) && labelDetails.length ? (
                          <>
                            {labelDetails?.map((item, index) => (
                              <Chips
                                key={index}
                                txtChip={item}
                                enabledBgColor="var(--primary-nav)"
                                disableIcon={true}
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  return;
                                }}
                                enabledTextColor="var(--text-primary)"
                              />
                            ))}
                          </>
                        ) : (
                          <p className="text-font-sm text-text-primary">
                            No labels assigned.
                          </p>
                        )}
                      </div>
                    </CommonContainerCard>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* ---------------------------------------------------------------------------------Card Detail End----------------------------------------------------------------------------------- */}
          `
          {/* ------------------------------------------------------------------------------------------------------------------------------------Timeline Div end-------------------------------------------------------------------------------------------- */}
        </div>
      )}
    </>
  );
};

export default PrivateTxnDetail;
